import { TEqualityFunction } from '@core/js/store/types';

import { REDUCER_NAMES } from '../constants';
import { useCustomSelector } from '../hooks/useCustomSelector';
import { TCustomUserSelector } from '../types';

import { ICustomUserState } from './types';

export const useCustomUserSelector = <TSelected = ICustomUserState>(
    selector: TCustomUserSelector<TSelected>,
    equalityFn?: TEqualityFunction<TSelected>
) => useCustomSelector<
    TSelected,
    typeof REDUCER_NAMES.CUSTOM_USER_REDUCER
>(REDUCER_NAMES.CUSTOM_USER_REDUCER, selector, equalityFn);

